import script from "./RejectSiteRequestDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./RejectSiteRequestDialog.vue?vue&type=script&setup=true&lang=ts"

import "./RejectSiteRequestDialog.vue?vue&type=style&index=0&id=659071e3&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-659071e3"]])

export default __exports__